
import React, { useEffect, useState } from 'react';
import API from '../../Services/Dashboard';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ProductTypeModal = ({ type, onClose }) => {
    const [productTypeList, setProductTypeList] = useState([]);
    const [selectedProductType, setSelectedProductType] = useState("");

    // useEffect(() => {
    //     getProductTypeData();
    // }, []);

    useEffect(() => {
        const id = localStorage.getItem("id")
        if (id != null) {
            getProductTypeData();
        }
        else {
            window.location.replace("/Login");
        }
    }, []);

    const getProductTypeData = async () => {
        try {
            const response = await API.getProductType();
            const data = response?.data?.data || [];
            setProductTypeList(data);
        } catch (error) {
            console.error("Failed to fetch product types", error);
            if (error?.response?.status === 403) {
                window.location.replace("/Login")
            } else {
                toast.error("Failed to fetch product types.");
            }
        }
    };

    const handleLogout = () => {
        localStorage.clear();
        window.location.href = '/Login';
    };

    const handleProceed = () => {
        if (!selectedProductType) {
            toast.error("Please select a product type.");
            return;
        }

        try {
            const parsed = JSON.parse(selectedProductType);
            const id = parsed.id;
            const isWaiverRequired = parsed.isWaiverRequired;

            console.log('id:', id);
            console.log('isWaiverRequired:', isWaiverRequired);

            // ✅ Save both to localStorage
            localStorage.setItem("selectedProductTypeId", id.toString());
            localStorage.setItem("isWaiverRequired", isWaiverRequired.toString());

            // 🔁 Proceed to next page
            window.location.replace("/CardSwipe");
            onClose();
        }
        //  catch (error) {
        //     toast.error("Something went wrong. Please try again.");
        //     console.error("Failed to parse selected product type:", error);
        // }
        catch (error) {
            console.error("Failed to process product type:", error);
            if (error?.response?.status === 403) {
                window.location.replace("/Login")
            } else {
                toast.error("Something went wrong. Please try again.");
            }
        }
    };




    if (!type) return null;

    return (
        <div style={modalOverlayStyle}>
            <div style={modalCardStyle}>
                <div style={headerStyle}>
                    <h4 style={{ margin: 0, fontWeight: 'bold', fontFamily: '"Times New Roman", Times, serif' }}>
                        Select Product Type
                    </h4>

                    <button
                        onClick={handleLogout}
                        className='btn rounded-0'
                        style={{ backgroundColor: "rgb(106, 75, 183)", color: "white" }}
                    // style={logoutButtonStyle}
                    //onMouseEnter={(e) => e.target.style.backgroundColor = '#e04b4b'}
                    //onMouseLeave={(e) => e.target.style.backgroundColor = '#ff5c5c'}

                    >
                        Logout
                    </button>
                </div>

                <div style={bodyStyle}>
                    <label htmlFor="product-select" style={{ fontWeight: 'bold', marginBottom: '8px' }}>
                        Product Type
                    </label>
                    <select
                        id="product-select"
                        style={selectStyle}
                        value={selectedProductType}
                        onChange={(e) => setSelectedProductType(e.target.value)}
                    >
                        <option value="">Select</option>
                        {/* {productTypeList.map((item) => (
                            <option key={item.id} value={item.id,item.is_waiver_required}>
                                {item.name}
                            </option>
                        ))} */}
                        {productTypeList.map((item) => (
                            <option
                                key={item.id}
                                value={JSON.stringify({ id: item.id, isWaiverRequired: item.is_waiver_required })}
                            >
                                {item.name}
                            </option>
                        ))}

                    </select>
                </div>

                <div style={footerStyle}>
                    <button
                        className='rounded-0'
                        onClick={handleProceed}
                        style={buttonStyle}
                        onMouseEnter={(e) => e.target.style.backgroundColor = '#5933a6'}
                        onMouseLeave={(e) => e.target.style.backgroundColor = '#6a4bb7'}
                    >
                        PROCEED
                    </button>
                </div>

                <ToastContainer />
            </div>
        </div>
    );
};

const modalOverlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 999,
    padding: '20px',
};

const modalCardStyle = {
    backgroundColor: '#fff',
    padding: '30px 24px',
    borderRadius: '12px',
    width: '100%',
    maxWidth: '480px',
    boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
};

const headerStyle = {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderBottom: '1px solid #eee',
    paddingBottom: '10px',
};

const bodyStyle = {
    display: 'flex',
    flexDirection: 'column',
};

const selectStyle = {
    width: '100%',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
    fontSize: '16px',
    outline: 'none',
};

const footerStyle = {
    display: 'flex',
    justifyContent: 'center',
};

const buttonStyle = {
    backgroundColor: '#rgb(106, 75, 183)',
    color: '#fff',
    border: 'none',
    padding: '12px 24px',
    borderRadius: '6px',
    fontSize: '16px',
    fontWeight: '600',
    cursor: 'pointer',
    width: '100%',
    transition: 'background 0.3s ease',
};

const logoutButtonStyle = {
    backgroundColor: '#rgb(106, 75, 183)',
    color: '#fff',
    border: 'none',
    padding: '8px 14px',
    borderRadius: '6px',
    cursor: 'pointer',
    fontSize: '14px',
    fontWeight: 'bold',
    transition: 'background 0.3s ease',
};

export default ProductTypeModal;
